<ng-container *ngIf="!isLoading else loading">
	<div class="card-title flex-space-between">
		<span>Weekly exception report</span>
		<button class="download-btns" type="button" cdkFocusInitial mat-button (click)="onBtExport()"
			*ngIf="exceptionReportMap && exceptionReportMap.size > 0">
			<span class="survey-button-label">Download weekly report</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:download"></mat-icon>
		</button>
	</div>
	<div *ngFor="let entry of exceptionReportMap | keyvalue">
		<div class="exception-report-block">
			<div class="icon-status-container">
				<mat-icon color="accent" svgIcon="md:pin"></mat-icon>
				<span class="doc-no">{{entry.key}}</span>
			</div>
		</div>
		<div class="details-container" *ngFor="let exceptionReport of entry.value">
			<span class="bold-class">{{buildYearWeek(exceptionReport.yearWeek)}}</span>
			<div class="card-infos"
				*ngIf="exceptionReport.commentFromCustomer && exceptionReport.commentFromCustomer.length > 0">
				<div class="card-info">
					<span class="card-info-label" translate>exception-report.comment-by-customer</span>
					<span class="card-info-value">{{exceptionReport.commentFromCustomer}}</span>
				</div>
			</div>
			<div class="card-infos"
				*ngIf="exceptionReport.commentFromCuse && exceptionReport.commentFromCuse.length > 0">
				<div class="card-info">
					<span class="card-info-label" translate>exception-report.comment-by-am</span>
					<span class="card-info-value">{{exceptionReport.commentFromCuse}}</span>
				</div>
			</div>
		</div>
	</div>
	<div class="no-reports" *ngIf="!exceptionReportMap || exceptionReportMap.size === 0">No reports to display</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner class="loading-spinner-small-container"></copo-loading-spinner>
</ng-template>